import Vue from 'vue'

export const DownloadsMutations = {
  addDownloadRequest (state, id) {
    state.requests.push({
      description: 'Pending',
      error: null,
      id: id,
      progress: null,
      size: null,
      url: null,
      visible: true,
    })
  },

  updateDownloadRequest (state, request) {
    const idx = state.requests.findIndex(d => d.id === request.download_id)
    if (idx < 0) return

    const download = state.requests[idx]

    Vue.set(state.requests, idx, {
      ...download,
      description: request.description,
      error: request.error,
      progress: request.progress,
      size: request.size,
      url: request.url,
    })
  },

  removeDownloadRequest (state, id) {
    const idx = state.requests.findIndex(d => d.id === id)
    if (idx < 0) return

    state.requests.splice(idx, 1)
  },
}
